export default {
  async index(params) {
    const {data} = await Vue.http.get('ticketing/pre_purchase_fares', {params})
    return data
  }
}
